export function ingredientCase (text) {
  return text.replace(/\b[A-Z][A-Z]+\b/g, word => ['CI', 'PEG', 'PPG', 'BHT', 'BHA', 'EDTA', 'UV'].includes(word) ? word : word[0] + word.slice(1).toLowerCase())
}
